import React from 'react';

interface State {
    forceUpdate: () => void;
}

interface TMP {
    children: (props: {forceUpdate: () => void}) => React.ReactNode;
}

class ForceUpdate extends React.PureComponent<TMP, State> {

    constructor(props: TMP) {
        super(props);

        this.state = {
            forceUpdate: this.update,
        };
    }

    update = () => {
        this.setState({
            forceUpdate: () => { this.update(); },
        });
    }

    render() {
        return this.props.children({forceUpdate: this.state.forceUpdate});
    }
}

export default ForceUpdate;
